<template lang="pug">
b-modal#rejectTicketAffiliate(
  ref="rejectTicketAffiliate"
  :title='$t("ui.combine.reject_affiliate_ticket")'
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th(colspan="2")
              span  {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.affiliate") }}
            td
              span {{ ticketDetail.account_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:title="$n(ticketDetail.amount, 'currency')" :class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}
          
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    div(slot="modal-footer")
      SubmitButton.float-right(icon="fa fa-ban" :text="$t('ui.reject')" @click="rejectTicket()" size="sm" variant="danger").mr-1
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  props: {
    ticketDetail: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      remark: '',
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    remark: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.remark = '';
    },
    rejectTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmRejectTicket();
      }
    },
    confirmRejectTicket: function() {
      let url = config.ticketRejectAffiliateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.rejectTicketAffiliate.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {

          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.rejectTicketAffiliate.hide();
    },
  }
};
</script>
